import axios from "axios";
import { IP } from "./config";
//查询用户进入小程序的数据
export async function selectUser() {
  var resp = await axios.post(`${IP}/wxuser/select`, {});
  return resp.data;
}
//查询用户进入小程序的数据 根据userId,phone筛选查询
export async function seleteUserByName(data) {
  var resp = await axios.post(`${IP}/wxuser/seleteUserByName`, {
    data,
  });
  return resp.data;
}
//修改进入小程序的数据
export async function updateUserByid(id, business) {
  var resp = await axios.post(`${IP}/wxuser/update`, {
    id,
    business,
  });
  return resp;
}
//删除进入小程序的数据
export async function deldeteUserByid(id) {
  var resp = await axios.post(`${IP}/wxuser/delete`, {
    id,
    // total:8,pageSize,name
  });
  return resp;
}
